import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { UtilsService } from 'src/app/core/services/utils.service';

@Injectable({
  providedIn: 'root',
})
export class TransactionExternalService extends BaseProvider {
  itemToEdit: any = { Id: null };
  transactionId: any = 'new';
  visibleModule: any = 'main';
  timeline: any = [];
  isReturning: boolean = false;

  searchList: any = [];
  transactionRefresher = new Subject();
  afterTransactionRefresh = new Subject();
  
  sentTransactionTypeId: any;
  filter: any = '';
  stats: any;
  counter: any;
  copyAmount: number = 1;
  proponent: any = {};
  constructor(
    public globals: GlobalsService,
    public http: HttpClient,
    public ls: LsHelperService,
    public authService: AuthService,
    public utilsService: UtilsService
  ) {
    super();

    this.baseUrl = 'userProcess';
  }

  getLookups() {
    return new Promise((resolve, reject) => {
      if (this.lookups) {
        resolve(this.lookups);
      }

      this.url = this.globals.dataUrl + this.baseUrl + '/lookup';

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.lookups = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getById(id) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + '/' + id;

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.itemToEdit = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getTimeline(id) {
    return new Promise((resolve, reject) => {
      this.url =
        this.globals.dataUrl + this.baseUrl + '/process/' + id + '/timeline';

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.timeline = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getTransactionsForUser() {
    return new Promise((resolve, reject) => {
      this.url =
        this.globals.dataUrl +
        this.baseUrl +
        '/page/' +
        this.page +
        '/size/' +
        this.size;

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.list = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getFilteredTransactionsForUser() {
    return new Promise((resolve, reject) => {
      this.url =
        this.globals.dataUrl +
        this.baseUrl +
        '/page/' +
        this.page +
        '/size/' +
        this.size +
        '/filter/' +
        this.filter;

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.list = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getStats() {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + '/stats';

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.stats = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getProponentById(userId) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + 'userProfile/' + userId;

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.proponent = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  getCounter(id) {
    return new Promise((resolve, reject) => {
      this.url =
        this.globals.dataUrl +
        this.baseUrl +
        '/counter/processId/' +
        id +
        '/copies/' +
        this.copyAmount;

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.counter = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  searchTransactions(params) {
    this.list = [];
    return new Promise((resolve, reject) => {

      let statusId: any;

			statusId = params.statusId;

			if(params.statusId.label){
				statusId = params.statusId.label
			}

      this.url =
        this.globals.dataUrl +
        this.baseUrl +
        '/proponente/search/page/' +
        params.pageNumber +
        '/size/' +
        params.pageSize +
        '?term=' +
        params.term +
        this.utilsService.formatParamUri({
          paramField: statusId,
          paramName: 'status',
        }) +
        this.utilsService.formatParamUri({
          paramField: params.dateFrom,
          paramName: 'dateFrom',
        }) +
        this.utilsService.formatParamUri({
          paramField: params.dateTo,
          paramName: 'dateTo',
        }) +
        this.utilsService.formatParamUri({
          paramField: params.processType,
          paramName: 'processType',
        });

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.list = data.Data;
          //this.pageData(data.Data);

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  searchTransactionsAdvancedSearch(params) {
    return new Promise((resolve, reject) => {
      this.url =
        this.globals.dataUrl +
        'capitalCase/search/advanced' +
        '/page/' +
        params.pageNumber +
        '/size/' +
        params.pageSize +
        '?clientName=' +
        params.clientName +
        '&caseNumber=' +
        params.caseNumber +
        '&finca=' +
        params.finca +
        '&loanNumber=' +
        params.loanNumber;

      this.http.get(this.url).subscribe(
        (data: any) => {
          this.list = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  startTransaction(params) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl;

      this.http.post(this.url, params).subscribe(
        (data: any) => {
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  attendTransaction(processId) {
    return new Promise((resolve, reject) => {
      this.url =
        this.globals.dataUrl + this.baseUrl + `/process/${processId}/attend`;

      this.http.post(this.url, null).subscribe(
        (data: any) => {
          
          resolve(data);
          
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  submitTransaction(processId) {
    return new Promise((resolve, reject) => {
      this.url =
        this.globals.dataUrl + this.baseUrl + `/process/${processId}/submit`;

      this.http.post(this.url, null).subscribe(
        (data: any) => {
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  userCanAttendCase() {
    var canAttend = false;

    if (
      this.itemToEdit.CurrentUserCanAttendCase == 1 &&
      this.itemToEdit.AssignedToCurrentUser != 1
    ) {
      canAttend = true;
    }

    return canAttend;
  }

  userCanInteract() {
    var canInteract = false;
    var canAttendProcesses = this.authService.hasPolicyBool(
      'CanAttendProcesses'
    );

    if (
      this.itemToEdit.AssignedToCurrentUser == 1 ||
      this.itemToEdit.CreatedByCurrentUser == 1 ||
      canAttendProcesses
    ) {
      canInteract = true;
    }

    return canInteract;
  }

  deleteTransaction(transactionId) {
    return new Promise((resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + `/${transactionId}`;

      this.http.delete(this.url).subscribe(
        (data: any) => {
          resolve(data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  userCreatedCase() {
    var createdCase = false;

    if (this.itemToEdit.CreatedByCurrentUser == 1) {
      createdCase = true;
    }

    return createdCase;
  }
}
